// 贷款首页推荐位VTOOLS配置
export interface ILoanHomeConfItem {
    prodNo: string
    prodName: string
    tags: string
    limitDescInit: string
    btnInit: string
    btnNormal: string
    btnUsing: string
    btnUpload: string
    btnReview: string;
    ccyCode: string
    isDefault: number
    prodOrder: number
    openType: number
    isOffLine: number
    limitDescNormal: string
    limitDescUsing: string
    limitDescUpload: string
    limitDescReview: string
    updateTime: number
    btnIncrease: string
}

export interface ILink {
    link: string
    userStatus: number
    linkType: string | 'weex'
    // 是否在跳转前置校验账户信息
    checkAccount: boolean | false
}

// 1-未申请；2-待上传文件；3-文件审核中；4-待确认额度; 5-已开通额度
export type ILimitStatus = 1 | 2 | 3 | 4 | 5

// 贷款首页推荐位UI数据项
export interface IWidgetConfItem {
    prodNo: string /* 产品ID */
    prodName: string /* 产品名称 */
    btnText: string /* 按钮文案 */
    descText: string /* 描述文案 */
    limit: string /* 额度 */
    tags: string /* 标签 */
    linkInfo: ILink /* 跳转链接 */
    limitStatus: ILimitStatus  /* 额度状态 */
}

// 产品开放方式
export enum IOpenType {
    ALL = 1, /* 全量 */
    WHITE = 2 /* 白名单 */
}

export interface ILoanCommonItem {
    'en-GB': string;
    'zh-CN': string;
    'zh-HK': string;
}

/**
 * 贷款入口信息
 */
export interface IEntranceInfo {
    /**
     * 用户状态
     */
    userStatus: number
    /**
     * 是否展示
     */
    isShow: boolean
    /**
     * icon背景图片
     */
    iconImgSrc: string
    /**
     * 跳转链接
     */
    link: string
    /**
     * 跳转方式
     */
    linkType: string

    /**
     * 是否做账户检查
     */
    checkAccount: boolean
}

export interface IGetTeslaWhiteListResp {
    whiteStatus: number
    userStatus: number
    uid: string
}

export enum IProofReviewStatus {
    PENDING = 10,               // 待审核
    REJECTED = 20,              // 拒绝
    PASS = 30,                  // 通过
    RETRY_UPLOAD = 40,          // 需要重新上传
}

export interface IGetSwitchConfReq {
    type: 'TESLA' | 'NPP',
}
